export default "__VITE_ASSET__BjjUHagISQHtPWYmu3KuwQ__"